import TheEmcdPuzzle from "./ui/index.vue";
import { h, render, getCurrentInstance } from "vue";

class EmcdPuzzle {
  async check({ node, context, pictureBlob, partBlob }) {
    return new Promise((resolve, reject) => {
      const instance = getCurrentInstance();
      const vnode = h(TheEmcdPuzzle, {
        pictureBlob,
        partBlob,
        context,
        onResolve: resolve,
        onReject: reject,
      });
      vnode.appContext = instance.appContext;
      render(vnode, node);
    });
  }
}

const EmcdPuzzleService = new EmcdPuzzle();

export default EmcdPuzzleService;
